import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import _ from 'lodash';
import ProductTable from './ProductTable';
import styles from '../SearchResults.scss';
import {Table, Thead, Tbody, Tr, Td, Th} from 'reactable';
import stylesTable from './ProductTableStyle.scss';
import InlineSVG from 'react-svg-inline';
import {Col, Row, Container} from 'src/components/Common/reactstrap/lib';

export default function Analogs(props) {
  let foundDetail = props.foundDetail;
  if (!foundDetail || !foundDetail.detailNum) {
    // если найдены похожие то дальше показывать похожие детали, которые имели в виду
    return (
      <p className={styles.emptyContent}> Аналогов не найдено</p>
    );
  }

  return (


    <Row className={`${styles.analogs} ${props.className}`}>
      <Col xs={12} md={5}>
        <Row className="pt-4">
          <Col sm={12} className="hidden-sm-down">
            <strong>Аналоги</strong>
          </Col>
          <Col sm={6} className="mt-3">
            Beru <a href="#" className="link">{foundDetail.detailNum}</a>
          </Col>
          <Col sm={6} className="mt-3">
            {foundDetail.name}
          </Col>
        </Row>
      </Col>
      <Col xs={12} md={7}>
        <ProductTable
          inStock={props.inStock}
          openToCartPopup={props.openToCartPopup}
          foundDetail={props.foundDetail}
          foundDetailOffers={props.foundDetailOffers}
          priceMinValue={props.priceMinValue}
          priceMaxValue={props.priceMaxValue}
          isAskSupplier={props.isAskSupplier}
          supplierFilterValues={props.supplierFilterValues}
          bestOfferValue={props.bestOfferValue}
        />

      </Col>
      <span className={styles.separator}></span>
    </Row>

  );
}

Analogs.propTypes = {
  openToCartPopup: PropTypes.func,
  foundDetail: PropTypes.object,
  foundDetailOffers: PropTypes.array,
  inStock: PropTypes.bool
};



/** WEBPACK FOOTER **
 ** ./src/components/SearchResults/elements/Analogs.jsx
 **/